import Swiper, {EffectFade, Navigation, Pagination } from "swiper";
Swiper.use([EffectFade, Pagination, Navigation]);
const Sliders = {

	init: () => {
		Sliders.initHeroSlider();
		Sliders.initVideoSlider();
		Sliders.initDonorsSlider();
		Sliders.initShapeGallerySlider();
	},

	initShapeGallerySlider: () => {
		const carousels = document.querySelectorAll(`.shape-gallery__swiper`);
		carousels.forEach((carousel) => {
			const parent = carousel.closest('.shape-gallery');
			const swiper = new Swiper(carousel, {
			    slidesPerView: 1,
			    spaceBetween: 24,
			    // loop: true,
				rewind: true,
			    navigation: {
			        nextEl: parent.querySelector('.shape-gallery__nav__btn--next'),
			        prevEl: parent.querySelector('.shape-gallery__nav__btn--prev'),
			    }
			});
		})
	},

	initDonorsSlider: () => {
		const carousels = document.querySelectorAll(`.news-events__donors__swiper`);
		carousels.forEach((carousel) => {
		    const swiper = new Swiper(carousel, {
		        slidesPerView: 4,
		        spaceBetween: 24,
		        loop: false,
				rewind: true,
		        autoplay: {
		            delay: 10000,
		            disableOnInteraction: false,
		        },
		        breakpoints: {
		            640: {
		                slidesPerView: 4,
		                spaceBetween: 24,
		            },
		        },
		        pagination: {
		            el: carousel.closest('.news-events__donors').querySelector('.news-events__donors__nav'),
		            clickable: true,
		        },
		    });
		})
	},

	initVideoSlider: () => {
		const carousels = document.querySelectorAll(`.video-carousel__swiper`);
		carousels.forEach((carousel) => {
		    const swiper = new Swiper(carousel, {
		        slidesPerView: 1,
		        spaceBetween: 24,
		        loop: false,
		        navigation: {
		            nextEl: carousel.closest('.video-carousel').querySelector('.video-carousel__nav__btn--next'),
		            prevEl: carousel.closest('.video-carousel').querySelector('.video-carousel__nav__btn--prev'),
		        },
		        rewind: true,
				breakpoints: {
					0: {
						slidesPerView: 1.075,
						spaceBetween: 24,
					},
					500: {
						slidesPerView: 1,
						spaceBetween: 24,
					}
				},
		    });
		})
	},

	initHeroSlider: () => {
		const carousels = document.querySelectorAll(`.hero__carousel`);
		carousels.forEach((carousel) => {
			const swiper = new Swiper(carousel, {
				slidesPerView: 1,
				autoHeight: true,
				spaceBetween: 0,
				loop: true,
				autoplay: {
					delay: 10000,
					disableOnInteraction: false,
				},
				pagination: {
					el: carousel.closest('.hero').querySelector('.hero__pagination'),
					clickable: true,
				},
				effect: "fade",
			});
		})
	}

}

export default Sliders;
